import { useMemo } from 'react';
import { useSubscription } from './SubscriptionProvider';

export const useHasAccess = (recipe) => {
  const { isSubscribed, isLoading } = useSubscription();

  const hasAccess = useMemo(() => {
    // Still loading - assume access to prevent flash of paywall
    if (isLoading) return true;

    // No recipe provided - allow access
    if (!recipe) return true;

    // Free recipes are always accessible
    if (recipe.isFree) return true;

    // Subscribed users have access to all recipes
    return isSubscribed;
  }, [isSubscribed, isLoading, recipe]);

  const shouldShowPaywall = useMemo(() => {
    // Don't show paywall while loading or if no recipe
    if (isLoading || !recipe) return false;

    // Show paywall for non-free recipes when not subscribed
    return !recipe.isFree && !isSubscribed;
  }, [isSubscribed, isLoading, recipe]);

  return {
    hasAccess,
    shouldShowPaywall,
    isLoading,
  };
};
